export const triggerGAEvent = (
	eventName: string,
	eventParams: Record<string, unknown> = {},
) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ event: eventName, ...eventParams });
};
